const tourRPA = [
  {
    selector: ".passo-1",
    content: (
      <>
        Pesquise suas empresas por <b>Razão Social</b>, <b>CNPJ</b>,{" "}
        <b>Status</b> e <b>Competência</b> aqui.
      </>
    ),
  },
  {
    selector: ".passo-5",
    content: (
      <>
        Clique aqui. A tela será atualizada automaticamente a cada{" "}
        <b>5 segundos</b>.
      </>
    ),
  },
  {
    selector: ".passo-2",
    content: (
      <>
        Acompanhe o <b>status da fila do robô</b> de cada empresa nesta área.
      </>
    ),
  },
  {
    selector: ".passo-3",
    content: (
      <>
        Visualize a <b>análise detalhada</b> da fila de robôs de cada empresa.
      </>
    ),
  },
  {
    selector: ".passo-4",
    content: (
      <>
        Clique aqui para <b>cadastrar sua primeira empresa</b>.
      </>
    ),
  },
];
const tourRPACadastro = [
  {
    selector: ".passo-1",
    content: (
      <>
        Comece importando os arquivos <b>SPED</b> ou{" "}
        <b>Excel de acordo com template</b> para realizar um cadastro de forma
        rápida.
      </>
    ),
  },
  {
    selector: ".passo-2",
    content: (
      <>
        Faça o download do <strong>template</strong>, preencha-o e realize o{" "}
        <strong>upload massivo</strong>.
      </>
    ),
  },
  {
    selector: ".passo-6",
    content: (
      <>
        Aqui você pode verificar se os <b>arquivos importados em massa</b> foram
        processados com <b>sucesso</b>.
      </>
    ),
  },
  {
    selector: ".passo-3",
    content: (
      <>
        O <b>Certificado A1</b> pode ser cadastrado acessando:
        <br />
        <b>Menu &gt; Gerenciador Empresas</b>.
      </>
    ),
  },
  {
    selector: ".passo-4",
    content: (
      <>
        Informe se o SPED será gerado automaticamente no <b>Sistema Domínio</b>.
        Preencha com <b>sim</b> ou <b>não</b>.
        <br />
        <br />
        <b>Importante:</b> cadastre o <b>login e senha</b> do{" "}
        <b>Sistema Domínio</b> em: <br />
        <b>Menu &gt; Gerenciador Empresas</b>
      </>
    ),
  },
];
const tourGerenciar = [
  {
    selector: ".passo-1",
    content: (
      <>
        Após cadastrar o <b>Sistema Domínio</b>, o <b>Certificado</b> e a{" "}
        <b>Empresa</b>, não se esqueça de <b>associar a empresa</b> ao
        certificado ou ao Sistema Domínio.
      </>
    ),
  },
  {
    selector: ".passo-2",
    content: (
      <>
        Após associar a empresa, <b>clique aqui</b>.<br />
        Para habilitar o botão, é necessário ter pelo menos{" "}
        <b>uma empresa associada a um certificado ou Sistema Domínio</b>.
      </>
    ),
  },
];
const tourRegra = [
  {
    selector: ".passo-1",
    content: (
      <>
        Após cadastrar a <b>Regra</b> e a <b>Empresa</b>, não se esqueça de{" "}
        <b>associar a empresa</b> a Regra
      </>
    ),
  },
  {
    selector: ".passo-2",
    content: (
      <>
        Após associar a empresa, <b>clique aqui</b>.<br />
        Para habilitar o botão, é necessário ter pelo menos{" "}
        <b>uma empresa associada a uma regra</b>.
      </>
    ),
  },
];

export default { tourRPA, tourRPACadastro, tourGerenciar, tourRegra };
